import { CompileResult } from "./Collection";

export class CompiledGeometryContainer {
    public reference: string;
    public textureReference: string;
    public geometry: CompileResult;

    constructor() {
        this.reference = null;
        this.textureReference = null;
        this.geometry = null;
    }
}